// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@conklin/MobiusOverrides/Tooltip";
import { paymentMethodStyles } from "@conklin/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod";
import { color } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

paymentMethodStyles.taxExmptionTooltip = {
    extendedStyles: {
        triggerWrapper: {
            css: css`
                margin-left: 6px;
                ${IconWrapper} {
                    color: ${color("common.ui9")};
                    &:hover {
                        color: ${color("common.ui10")};
                    }
                }
            `,
        },
    },
} as TooltipPresentationProps;
